import { useQuery } from "@tanstack/react-query";

import { STEP_API_ENDPOINT } from "../../utils/swr";
import { fetchJSONFromUrl } from "../../utils/utils";
import { queryConfig } from "./queryConfig";

export interface StakingAPYMap {
  [platform: string]: number;
}

const initialData = {} as StakingAPYMap;

export const useStakingAPYQuery = () =>
  useQuery<StakingAPYMap>(["apys", "data"], fetchStakingAPYQuery, {
    ...queryConfig,
    initialData,
  });

const fetchStakingAPYQuery = async () => {
  const stakingAPYMap: StakingAPYMap = await fetchJSONFromUrl(`${STEP_API_ENDPOINT}/v1/integration/staking/apy`);
  return stakingAPYMap;
};
